// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   ১. মূল কন্টেইনার এবং লেআউট (Layout & Base)
   ========================================== */
.log-page-container {
    width: 100%;
    min-height: calc(100vh - 100px); /* ভিউপোর্ট অনুযায়ী হাইট অ্যাডজাস্টমেন্ট */
    padding: 30px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* ডিভাইস সিলেক্ট করার সময় স্ক্রিনের মাঝখানে দেখানোর জন্য */
.log-page-container.is-centered {
    align-items: center;
    justify-content: center;
}

/* লগ ভিউয়ার চালু হলে টপ-অ্যালাইনড লেআউট */
.log-page-container.is-active {
    align-items: stretch;
    justify-content: flex-start;
}

.log-header-section {
    width: 100%;
    max-width: 900px; /* ডেস্কটপে যেন বেশি ছড়িয়ে না যায় */
    text-align: center;
    animation: fadeIn 0.4s ease-in-out; /* স্ক্রিন আসার সময় স্মুথ অ্যানিমেশন */
}

.log-title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 40px;
    color: #1e293b; /* আধুনিক ডার্ক স্লেট কালার */
    letter-spacing: -0.5px;
}

/* ==========================================
   ২. ডিভাইস কার্ড গ্রিড (Device Card Grid)
   ========================================== */
.device-card-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* ডেস্কটপে পাশাপাশি ৩টি সমান কলাম */
    gap: 30px;
    width: 100%;
    margin-top: 10px;
}

/* ==========================================
   ৩. একক কার্ড ডিজাইন (Single Card Design)
   ========================================== */
.device-status-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); /* স্মুথ ট্রানজিশন */
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
}

/* কার্ড হোভার ইফেক্ট */
.device-status-card:hover {
    transform: translateY(-6px);
    border-color: #3b82f6;
    box-shadow: 0 20px 25px -5px rgba(59, 130, 246, 0.1), 0 10px 10px -5px rgba(59, 130, 246, 0.04);
}

/* আইকন ব্যাকগ্রাউন্ড গোল সার্কেল */
.device-icon-wrapper {
    background: #eff6ff;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.device-status-card:hover .device-icon-wrapper {
    background: #3b82f6;
    transform: scale(1.05);
}

/* আইকন সাইজ ও কালার */
.device-icon-svg {
    font-size: 38px;
    color: #3b82f6;
    transition: color 0.3s ease;
}

.device-status-card:hover .device-icon-svg {
    color: #ffffff;
}

/* কার্ডের নিচের টেক্সট লেবেল */
.device-card-label {
    font-size: 18px;
    font-weight: 600;
    color: #334155;
    margin: 0;
    transition: color 0.3s ease;
}

.device-status-card:hover .device-card-label {
    color: #2563eb;
}

/* ==========================================
   ৪. লগ ভিউয়ার এরিয়া (Log Viewer Body)
   ========================================== */
.log-viewer-body {
    width: 100%;
    animation: slideUp 0.4s ease-out;
}

/* ==========================================
   ৫. রেসপনসিভ মিডিয়া কোয়েরি (Responsive Design)
   ========================================== */

/* ট্যাবলেট এবং ছোট স্ক্রিনের জন্য (Medium Screens) */
@media (max-width: 768px) {
    .log-title {
        font-size: 24px;
        margin-bottom: 30px;
    }
    
    .device-card-grid {
        grid-template-columns: repeat(2, 1fr); /* ট্যাবলেটে ২টি কলাম হয়ে যাবে */
        gap: 20px;
    }
    
    .device-status-card {
        padding: 30px 15px;
    }
    
    .device-icon-wrapper {
        width: 70px;
        height: 70px;
    }
    
    .device-icon-svg {
        font-size: 32px;
    }
}

/* মোবাইল স্ক্রিনের জন্য (Small Screens / Mobile) */
@media (max-width: 480px) {
    .log-page-container {
        padding: 15px 10px;
    }

    .log-title {
        font-size: 22px;
    }

    .device-card-grid {
        grid-template-columns: 1fr; /* মোবাইলে ১টি করে কার্ড পুরো লাইন জুড়ে থাকবে */
        gap: 15px;
    }

    .device-status-card {
        flex-direction: row; /* মোবাইলে আইকন উপরে না রেখে বামে এবং টেক্সট ডানে থাকবে (জায়গা বাঁচানোর জন্য) */
        justify-content: flex-start;
        padding: 20px;
        border-radius: 12px;
    }

    .device-icon-wrapper {
        width: 50px;
        height: 50px;
        margin-bottom: 0;
        margin-right: 20px; /* আইকনের ডানে স্পেস */
    }

    .device-icon-svg {
        font-size: 24px;
    }

    .device-card-label {
        font-size: 16px;
    }
}

/* ==========================================
   ৬. অ্যানিমেশন (Animations)
   ========================================== */
@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes slideUp {
    from { opacity: 0; transform: translateY(15px); }
    to { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/components/LogManage/LogManage.css"],"names":[],"mappings":"AAAA;;+CAE+C;AAC/C;IACI,WAAW;IACX,+BAA+B,EAAE,0CAA0C;IAC3E,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,2DAA2D;AAC3D;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,0CAA0C;AAC1C;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,gBAAgB,EAAE,mCAAmC;IACrD,kBAAkB;IAClB,kCAAkC,EAAE,sCAAsC;AAC9E;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc,EAAE,6BAA6B;IAC7C,sBAAsB;AAC1B;;AAEA;;+CAE+C;AAC/C;IACI,aAAa;IACb,qCAAqC,EAAE,oCAAoC;IAC3E,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;;+CAE+C;AAC/C;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iDAAiD,EAAE,oBAAoB;IACvE,kFAAkF;AACtF;;AAEA,uBAAuB;AACvB;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,+FAA+F;AACnG;;AAEA,mCAAmC;AACnC;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,sBAAsB;AACtB;IACI,eAAe;IACf,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA,+BAA+B;AAC/B;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;;+CAE+C;AAC/C;IACI,WAAW;IACX,gCAAgC;AACpC;;AAEA;;+CAE+C;;AAE/C,qDAAqD;AACrD;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,qCAAqC,EAAE,gCAAgC;QACvE,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,mDAAmD;AACnD;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B,EAAE,+CAA+C;QAC3E,SAAS;IACb;;IAEA;QACI,mBAAmB,EAAE,+EAA+E;QACpG,2BAA2B;QAC3B,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,kBAAkB,EAAE,sBAAsB;IAC9C;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;+CAE+C;AAC/C;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C","sourcesContent":["/* ==========================================\n   ১. মূল কন্টেইনার এবং লেআউট (Layout & Base)\n   ========================================== */\n.log-page-container {\n    width: 100%;\n    min-height: calc(100vh - 100px); /* ভিউপোর্ট অনুযায়ী হাইট অ্যাডজাস্টমেন্ট */\n    padding: 30px 20px;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n}\n\n/* ডিভাইস সিলেক্ট করার সময় স্ক্রিনের মাঝখানে দেখানোর জন্য */\n.log-page-container.is-centered {\n    align-items: center;\n    justify-content: center;\n}\n\n/* লগ ভিউয়ার চালু হলে টপ-অ্যালাইনড লেআউট */\n.log-page-container.is-active {\n    align-items: stretch;\n    justify-content: flex-start;\n}\n\n.log-header-section {\n    width: 100%;\n    max-width: 900px; /* ডেস্কটপে যেন বেশি ছড়িয়ে না যায় */\n    text-align: center;\n    animation: fadeIn 0.4s ease-in-out; /* স্ক্রিন আসার সময় স্মুথ অ্যানিমেশন */\n}\n\n.log-title {\n    font-size: 28px;\n    font-weight: 700;\n    margin-bottom: 40px;\n    color: #1e293b; /* আধুনিক ডার্ক স্লেট কালার */\n    letter-spacing: -0.5px;\n}\n\n/* ==========================================\n   ২. ডিভাইস কার্ড গ্রিড (Device Card Grid)\n   ========================================== */\n.device-card-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr); /* ডেস্কটপে পাশাপাশি ৩টি সমান কলাম */\n    gap: 30px;\n    width: 100%;\n    margin-top: 10px;\n}\n\n/* ==========================================\n   ৩. একক কার্ড ডিজাইন (Single Card Design)\n   ========================================== */\n.device-status-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 16px;\n    padding: 40px 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); /* স্মুথ ট্রানজিশন */\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n}\n\n/* কার্ড হোভার ইফেক্ট */\n.device-status-card:hover {\n    transform: translateY(-6px);\n    border-color: #3b82f6;\n    box-shadow: 0 20px 25px -5px rgba(59, 130, 246, 0.1), 0 10px 10px -5px rgba(59, 130, 246, 0.04);\n}\n\n/* আইকন ব্যাকগ্রাউন্ড গোল সার্কেল */\n.device-icon-wrapper {\n    background: #eff6ff;\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    margin-bottom: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n}\n\n.device-status-card:hover .device-icon-wrapper {\n    background: #3b82f6;\n    transform: scale(1.05);\n}\n\n/* আইকন সাইজ ও কালার */\n.device-icon-svg {\n    font-size: 38px;\n    color: #3b82f6;\n    transition: color 0.3s ease;\n}\n\n.device-status-card:hover .device-icon-svg {\n    color: #ffffff;\n}\n\n/* কার্ডের নিচের টেক্সট লেবেল */\n.device-card-label {\n    font-size: 18px;\n    font-weight: 600;\n    color: #334155;\n    margin: 0;\n    transition: color 0.3s ease;\n}\n\n.device-status-card:hover .device-card-label {\n    color: #2563eb;\n}\n\n/* ==========================================\n   ৪. লগ ভিউয়ার এরিয়া (Log Viewer Body)\n   ========================================== */\n.log-viewer-body {\n    width: 100%;\n    animation: slideUp 0.4s ease-out;\n}\n\n/* ==========================================\n   ৫. রেসপনসিভ মিডিয়া কোয়েরি (Responsive Design)\n   ========================================== */\n\n/* ট্যাবলেট এবং ছোট স্ক্রিনের জন্য (Medium Screens) */\n@media (max-width: 768px) {\n    .log-title {\n        font-size: 24px;\n        margin-bottom: 30px;\n    }\n    \n    .device-card-grid {\n        grid-template-columns: repeat(2, 1fr); /* ট্যাবলেটে ২টি কলাম হয়ে যাবে */\n        gap: 20px;\n    }\n    \n    .device-status-card {\n        padding: 30px 15px;\n    }\n    \n    .device-icon-wrapper {\n        width: 70px;\n        height: 70px;\n    }\n    \n    .device-icon-svg {\n        font-size: 32px;\n    }\n}\n\n/* মোবাইল স্ক্রিনের জন্য (Small Screens / Mobile) */\n@media (max-width: 480px) {\n    .log-page-container {\n        padding: 15px 10px;\n    }\n\n    .log-title {\n        font-size: 22px;\n    }\n\n    .device-card-grid {\n        grid-template-columns: 1fr; /* মোবাইলে ১টি করে কার্ড পুরো লাইন জুড়ে থাকবে */\n        gap: 15px;\n    }\n\n    .device-status-card {\n        flex-direction: row; /* মোবাইলে আইকন উপরে না রেখে বামে এবং টেক্সট ডানে থাকবে (জায়গা বাঁচানোর জন্য) */\n        justify-content: flex-start;\n        padding: 20px;\n        border-radius: 12px;\n    }\n\n    .device-icon-wrapper {\n        width: 50px;\n        height: 50px;\n        margin-bottom: 0;\n        margin-right: 20px; /* আইকনের ডানে স্পেস */\n    }\n\n    .device-icon-svg {\n        font-size: 24px;\n    }\n\n    .device-card-label {\n        font-size: 16px;\n    }\n}\n\n/* ==========================================\n   ৬. অ্যানিমেশন (Animations)\n   ========================================== */\n@keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n@keyframes slideUp {\n    from { opacity: 0; transform: translateY(15px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
